import { render, staticRenderFns } from "./MitHeader.vue?vue&type=template&id=37af9d7a&scoped=true"
import script from "./MitHeader.vue?vue&type=script&lang=js"
export * from "./MitHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af9d7a",
  null
  
)

export default component.exports